import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable, of } from "rxjs";
import { mergeMap, take } from "rxjs/operators";
import { IPaymentConfig } from "../models/payment.model";
import { DataService } from "../services/data/data.service";
import { PaymentService } from "../services/payment/payment.service";

@Injectable({
  providedIn: "root"
})
export class PaymentConfigResolverService implements Resolve<IPaymentConfig> {
  constructor(private dataService: DataService, private paymentService:PaymentService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IPaymentConfig> | Observable<never> {
    const id = route.paramMap.get("profileId");
    const paymentModes = this.paymentService.modes;
    return this.dataService.getPaymentConfig(id).pipe(
      take(1),
      mergeMap(item => {
        if (item) {
          paymentModes.forEach(mode => {
            if(!item[mode]) {item[mode]= {enabled:false}}
            else if(item[mode].enabled === undefined){
              item[mode]= {enabled:true}
            }
          })
          return of(item);
        } else {
          item = {};
          paymentModes.forEach(mode => {
            item[mode]= {enabled:false};
          })
          return of (item);
        }
      })
    );
  }
}
